import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getProviderAllSubservices,
  getSubServices,
  PROVIDER_SUB_SERVICES_GET_MANY,
  resetState,
  StateStatus,
  SUBSERVICE_RESTORE,
} from '@guryou/redux';

const useSubServices = ({ serviceId, silent, all = false }) => {
  const dispatch = useDispatch();
  const { data, status, version, entity, request } = useSelector(state => state.subServices.all);
  const restore = useSelector(state => state.subServices.restore);

  // The active list and the archived list (`all`) share this slice, so a cached result is only reusable when
  // it was fetched for the same service AND the same variant — otherwise switching between them shows stale rows.
  const isStale = status === StateStatus.LOADED && (request?.serviceId !== serviceId || !!request?.all !== all);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || isStale) {
      if (all) {
        dispatch(getProviderAllSubservices(serviceId, silent));
      } else {
        dispatch(getSubServices(serviceId, silent));
      }
    }
    if (restore.version) {
      dispatch(resetState(PROVIDER_SUB_SERVICES_GET_MANY));
      restore.version && dispatch(resetState(SUBSERVICE_RESTORE));
    }
  }, [all, dispatch, isStale, restore.version, serviceId, silent, status]);

  if (!serviceId) {
    return { data: null, status: StateStatus.NOT_INITIALIZED };
  }

  if (isStale) {
    return { data: [], status: StateStatus.LOADING, version, entity };
  }

  return { data: data || [], status, version, entity };
};

export default useSubServices;
